<!--
 * @Author: 月魂
 * @Date: 2021-11-24 11:07:27
 * @LastEditTime: 2021-12-06 09:55:11
 * @LastEditors: 月魂
 * @Description: 论坛列表
 * @FilePath: \seven-silk\src\views\ForumList.vue
-->
<template>
  <div class="box">
    <img src="../assets/back.png" alt="" class="back" @click="() => this.$router.go(-1)">
    <div class="header">
      <div class="title">{{ this.$t('intro.name') }}</div>
      <div class="subTitle">{{ this.$t('forum.title') }}</div>
    </div>
    <!-- 演出列表 -->
    <div class="list">
      <div class="item" @click="jump(forum.id)" v-for="forum in this.$t('forum.list')" :key="forum.id">
        <div class="top">
          <div class="img">
            <img :src="`http://image.wearetogether.com.cn/seven-forum-poster-${forum.id}.png`" alt="" width="100%">
          </div>
          <div class="des">{{ forum.des[0] }}</div>
        </div>
        <div class="bottom">
          <div class="name">{{ forum.title }}</div>
          <div class="origin">{{ forum.host }}</div>
          <div class="time" v-show="forum.time">{{ forum.time }}</div>
          <div class="address">{{ forum.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForumList',
  components: {
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  methods: {
    jump(id) { // 此处需传入剧目id
      this.$router.push(`/forum-detail/${id}`)
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  min-height: 100%;
  background-image: linear-gradient(to right, #ed6e5a, #b27c9f);
  position: relative;
  .back {
    position: absolute;
    top: 16px;
    left: 10px;
    width: 24PX;
    z-index: 10;
  }
  .header {
    // background-image: url('../assets/index/forum.png');
    background-size: cover;
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px 30px;
    word-break: break-word;
    padding-bottom: 0;
    .title {
      width: 100%;
      font-size: 20px;
      text-align: center;
    }
    .subTitle {
      width: 100%;
      text-align: center;
      font-size: 20px;
    }
  }
  // 演出列表
  .list {
    max-width: 1200PX;
    margin: auto;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      width: 100%;
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      .top {
        position: relative;
        .img {
          width: 100%;
          img {
            display: block;
          }
        }
        .des {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0 10px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          background-color: rgba(0, 0, 0, 0.8);
          color: #fff;
          font-size: 14px;
        }
      }
      .bottom {
        display: flex;
        flex-wrap: wrap;
        .name {
          width: 100%;
          line-height: 2;
          font-size: 16px;
        }
        .origin {
          width: 100%;
          font-size: 14px;
          color: #9a9a9a;
        }
        .time {
          font-size: 12px;
          margin-right: 20px;
          color: #9a9a9a;
        }
        .address {
          font-size: 12px;
          color: #9a9a9a;
        }
      }
    }
    @media (min-width: 1200PX) {
      padding: 0;
      margin-top: 10px;
      .item {
        width: 49%;
      }
    }
  }
}
</style>
